import { Reducer } from 'redux';
import {
    SERVICE_SESSIONS_CLEAR_WARNINGS_ACTION_TYPE,
    SERVICE_SESSIONS_ERROR_ACTION_TYPE,
    SERVICE_SESSIONS_FETCH_START_ACTION_TYPE,
    SERVICE_SESSIONS_FETCH_SUCCESS_ACTION_TYPE,
    SERVICE_SESSIONS_RESET_ACTION_TYPE,
    SERVICE_SESSIONS_SAVE_START_ACTION_TYPE,
    SERVICE_SESSIONS_SAVE_SUCCESS_ACTION_TYPE,
    ServiceSessionsAction
} from 'actions/serviceSessions/ServiceSessionsActionsTypes';
import { ServiceSessionsState, ServiceSessionsStatus } from './ServiceSessionsState';

const initialState: ServiceSessionsState = {
    days: [],
    status: ServiceSessionsStatus.Initial,
    loading: false,
    saving: false,
    warnings: [],
    assignmentErrors: []
};

export const serviceSessionsReducer: Reducer<ServiceSessionsState, ServiceSessionsAction> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case SERVICE_SESSIONS_RESET_ACTION_TYPE:
            return {
                ...initialState
            };
        case SERVICE_SESSIONS_FETCH_START_ACTION_TYPE:
            return {
                ...(action.payload.businessArea === state.businessArea ? state : initialState),
                status: ServiceSessionsStatus.Fetching,
                loading: true,
                businessArea: action.payload.businessArea,
                startDate: action.payload.startDate,
                error: undefined
            };
        case SERVICE_SESSIONS_FETCH_SUCCESS_ACTION_TYPE:
            return {
                ...state,
                status: ServiceSessionsStatus.FetchSuccess,
                loading: false,
                startDate: action.payload.startDate,
                endDate: action.payload.endDate,
                days: action.payload.days,
                assignmentErrors: []
            };
        case SERVICE_SESSIONS_SAVE_START_ACTION_TYPE:
            return {
                ...state,
                status: ServiceSessionsStatus.Saving,
                saving: true,
                warnings: [],
                assignmentErrors: [],
                error: undefined
            };
        case SERVICE_SESSIONS_SAVE_SUCCESS_ACTION_TYPE:
            return {
                ...state,
                status: ServiceSessionsStatus.SaveSuccess,
                saving: false,
                warnings: action.payload.warnings,
                assignmentErrors: []
            };
        case SERVICE_SESSIONS_CLEAR_WARNINGS_ACTION_TYPE:
            return {
                ...state,
                warnings: [],
                assignmentErrors: []
            };
        case SERVICE_SESSIONS_ERROR_ACTION_TYPE:
            return {
                ...state,
                status: ServiceSessionsStatus.Error,
                loading: false,
                saving: false,
                error: action.payload.error,
                assignmentErrors: action.payload.assignmentErrors
            };
        default:
            return state;
    }
};

export default serviceSessionsReducer;
